import { Component, OnInit, Inject } from '@angular/core';
import { CustomerLocationsService } from '@app/shared/services/customer-locations/customer-locations.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-history-locations',
  templateUrl: './dialog-history-locations.component.html',
  styleUrls: ['./dialog-history-locations.component.sass'],
})
export class DialogHistoryLocationsComponent implements OnInit {
  history: any;

  constructor(
    private locationService: CustomerLocationsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.locationService
      .listHistory(this.data.endpoint, this.data.idTrade)
      .subscribe((response) => {
        this.history = response;
      });
  }
}
